import PropTypes from 'prop-types';

export default function Button({ id = '', primary = false, onClick, disabled = false, testId = '', center = false, children }) {
	const classes = ['btn'];
	primary && classes.push('btn--primary');
	center && classes.push('btn--center');

	return (
		<div className="btn-ctr">
			<button data-testid={testId} id={id} onClick={onClick} className={classes.join(' ')} disabled={disabled}>
				{children}
			</button>
		</div>
	);
}

Button.propTypes = {
	center: PropTypes.bool,
	children: PropTypes.node.isRequired,
	disabled: PropTypes.bool,
	id: PropTypes.string,
	onClick: PropTypes.func,
	primary: PropTypes.bool,
	testId: PropTypes.string,
};
